module.exports = __webpack_public_path__ + "hu.svg?1debd7eab581ac9d6ba84a4b1660116f";